export interface IdentityAssignment {
  id: string;
  name?: string;
  roleId?: string;
  roleIds?: string[];
  attributeIds: string[];
}

export const IDENTITY_STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  DEACTIVATED: 'DEACTIVATED',
} as const;

export type IdentityDisplayStatus =
  (typeof IDENTITY_STATUS)[keyof typeof IDENTITY_STATUS];

export interface Identity {
  id: string;
  name: string;
  email: string;
  type: string;
  teams: string[];
  accessCategory: string;
  phoneNumber: string;
  assignments: IdentityAssignment[];
  status: IdentityDisplayStatus;
  createdAt: string;
}

export interface IdentityActionHandlers {
  onAssign?: (identity: Identity) => void;
}
